













import Vue from 'vue'
import Navbar from '@/components/Navbar.vue'
import AOS from 'aos'
import Cases from './db'

export default Vue.extend({
    name: 'Index',
    components: { Navbar },
    data(){
        return { cases: Cases() }
    },
    beforeMount () {
        document.addEventListener('aos:in', this.aosEvent)
        window.addEventListener('resize', this.aosRefresh)
    },
    created () {
        AOS.init({
            disable: 'phone'
        })
    },
    beforeDestroy(){
        document.removeEventListener('aos:in', this.aosEvent)
    },
    methods: {
        aosEvent (e:Event) {},
        aosRefresh () { AOS.refresh() }
    }
})
